// extracted by mini-css-extract-plugin
module.exports = {"atc_container":"mobileStickyAtc_atc_container__VAWtO","atc_button":"mobileStickyAtc_atc_button__L0EW4","slide":"mobileStickyAtc_slide__LKx4_"};